import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchRideTransactions = async ({ rideId, refund }: { rideId: string; refund?: boolean }) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      rideId,
      refund,
    },
    query: graphql(`
      query RideTransactions($rideId: String!, $refund: Boolean) {
        rideTransactions(refund: $refund, rideId: $rideId) {
          count
          rows {
            id
            amount
          }
        }
      }
    `),
  });

  return response.data.rideTransactions;
};
